import { render, staticRenderFns } from "./V2RepsFilterDropdown.vue?vue&type=template&id=313047f8&scoped=true&"
import script from "./V2RepsFilterDropdown.vue?vue&type=script&lang=js&"
export * from "./V2RepsFilterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./V2RepsFilterDropdown.vue?vue&type=style&index=0&id=313047f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313047f8",
  null
  
)

export default component.exports